import React from "react";
import styled, { CSSProperties } from "styled-components";

const Container = styled.div`
	position: absolute;
    width: 100%;
    height: 100%;
	left: 0;
	top: 0;
    background-color: rgba(123, 123, 123, 0.3);
    img {
        width: 60px;
        height: 60px;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
    }
`;

interface ILoadingProps {
    iconStyle?: CSSProperties;
}

export default function Loading(props: ILoadingProps) {
	return (
		<Container>
			<img
				src="https://litb-cgis.rightinthebox.com/lightsource/img/common/index_loading_box_36x36_9e0408963dce0b89.gif"
				alt="loading"
                style={props.iconStyle}
			/>
		</Container>
	);
}
